import jwtDecode from "jwt-decode";

const JwtDecode=()=>{
    const token = localStorage.getItem("accessToken");
    const decode = jwtDecode(token);
    return decode;
}
export default JwtDecode;